<template>
  <layout>
    <rdkm-title>
      {{ $t('Локализация') }}
    </rdkm-title>
    <div class="tile">    
      <filter-form :translation="query.translation" 
                  v-on:search="$refs.grid.filter($event, true)">
      </filter-form>       
      <rdkm-grid ref="grid" :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>        
        <grid-column name="ruVal" :title="$t('Русский')"></grid-column>       
        <grid-column name="enVal" :title="$t('Английский')"></grid-column>       
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import FilterForm from "./Filter.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "Settings",
  props: ["query"],
  components: {
    "filter-form": FilterForm, 
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
